import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "d-flex align-center justify-space-between" }
const _hoisted_10 = { class: "d-flex gap-2" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "d-flex align-center justify-space-between" }
const _hoisted_13 = { class: "d-flex gap-2" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "d-flex align-center justify-space-between" }
const _hoisted_16 = { class: "d-flex gap-2" }
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = { class: "d-flex align-center justify-space-between" }
const _hoisted_19 = { class: "d-flex gap-2" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "d-flex align-center justify-space-between" }
const _hoisted_22 = { class: "d-flex gap-2" }
const _hoisted_23 = { class: "mb-4" }
const _hoisted_24 = { class: "d-flex align-center justify-space-between" }
const _hoisted_25 = { class: "d-flex gap-2" }
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = { class: "d-flex align-center gap-2" }
const _hoisted_28 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_29 = { class: "d-flex align-center justify-space-between" }
const _hoisted_30 = { class: "d-flex gap-2" }
const _hoisted_31 = { class: "mb-2" }

import { ref, computed, watch } from 'vue';
import axios from 'axios';

interface Props {
  modelValue: boolean;
  lebYm?: string;
  sisulCode?: string;
  currentData?: any[];
  isMagam?: boolean;
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'apply-bulk-time-pay', value: string): void;
  (e: 'apply-bulk-time-pay-family-60', value: string): void;
  (e: 'apply-bulk-time-pay-family-90', value: string): void;
  (e: 'apply-bulk-health-insurance', value: boolean): void;
  (e: 'apply-bulk-holiday-allowance', value: boolean): void;
  (e: 'apply-bulk-overtime-allowance', value: boolean): void;
  (e: 'apply-bulk-retirement', value: boolean): void;
  (e: 'apply-bulk-meal-allowance', value: boolean): void;
  (e: 'apply-bulk-long-service-auto-calculate'): void;
  (e: 'apply-bulk-long-service-clear'): void;
  (e: 'apply-bulk-bosu-edu-pay', value: string): void;
  (e: 'apply-bulk-bosu-edu-pay-clear'): void;
  (e: 'apply-bulk-labor-day-allowance', value: boolean): void;
  (e: 'apply-all-previous-settings', value: { allData: Array<{ lebYm: string; data: any[] }>; recentData: { lebYm: string; data: any[] } }): void;
  (e: 'reset-all-settings'): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SetModal',
  props: {
    modelValue: { type: Boolean },
    lebYm: {},
    sisulCode: {},
    currentData: {},
    isMagam: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "apply-bulk-time-pay", "apply-bulk-time-pay-family-60", "apply-bulk-time-pay-family-90", "apply-bulk-health-insurance", "apply-bulk-holiday-allowance", "apply-bulk-overtime-allowance", "apply-bulk-retirement", "apply-bulk-meal-allowance", "apply-bulk-long-service-auto-calculate", "apply-bulk-long-service-clear", "apply-bulk-bosu-edu-pay", "apply-bulk-bosu-edu-pay-clear", "apply-bulk-labor-day-allowance", "apply-all-previous-settings", "reset-all-settings"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// 모달 열림/닫힘 상태
const isOpen = ref(props.modelValue);

// 일괄 시간당 임금 변경
const bulkTimePay = ref('');
const bulkTimePayFamily60 = ref('');
const bulkTimePayFamily90 = ref('');

// 이전 달 데이터 로딩 상태
const loadingPreviousData = ref(false);

// 과거 데이터 존재 여부
const hasPreviousData = ref(false);

// 적용 상태 추적
const lastApplied = ref<{
  allSettings?: boolean;
  timePay?: string;
  timePayFamily60?: string;
  timePayFamily90?: string;
  healthInsurance?: boolean;
  holiday?: boolean;
  overtime?: boolean;
  retirement?: boolean;
  meal?: boolean;
  longServiceAutoCalculate?: boolean;
  longServiceClear?: boolean;
  laborDay?: boolean;
}>({});

// 5월 여부 확인
const isLaborDayMonth = computed(() => {
  if (!props.lebYm) return false;
  return props.lebYm.substring(4, 6) === '05';
});

// 2025년 이하 여부 확인 (근로자의날 특별 처리 대상)
const isLegacyYear = computed(() => {
  if (!props.lebYm) return false;
  const year = parseInt(props.lebYm.substring(0, 4));
  return year <= 2025;
});

// 과거 데이터 체크 함수
const checkPreviousData = async () => {
  if (!props.sisulCode || !props.lebYm) {
    hasPreviousData.value = false;
    return;
  }
  
  const currentYear = parseInt(props.lebYm.substring(0, 4));
  const currentMonth = parseInt(props.lebYm.substring(4, 6));
  const currentLebYm = props.lebYm;
  
  try {
    let searchMonth = currentMonth - 1;
    
    // 현재 연도 내에서만 검색 (1월부터 현재 월-1까지)
    while (searchMonth >= 1) {
      const targetLebYm = `${currentYear}${String(searchMonth).padStart(2, '0')}`;
      
      if (targetLebYm === currentLebYm) {
        searchMonth--;
        continue;
      }
      
      try {
        const response = await axios.get('/api/calc/caregiver-member-join', {
          params: {
            sisulCode: props.sisulCode,
            lebYm: targetLebYm,
          },
        });
        
        const data = response.data.data || [];
        
        if (data.length > 0) {
          hasPreviousData.value = true;
          return;
        }
      } catch (error) {
        // 에러 무시하고 계속 검색
      }
      
      searchMonth--;
    }
    
    hasPreviousData.value = false;
  } catch (error) {
    hasPreviousData.value = false;
  }
};

// 모달 닫기
const close = () => {
  emit('update:modelValue', false);
  // 입력값 초기화
  bulkTimePay.value = '';
  bulkTimePayFamily60.value = '';
  bulkTimePayFamily90.value = '';
  // 적용 상태 초기화
  lastApplied.value = {};
};

// 일괄 시간당 임금 적용 (일반)
const applyBulkTimePay = () => {
  if (!bulkTimePay.value || bulkTimePay.value === '0') return;
  
  const confirmed = confirm(`모든 일반 시간당 임금을 ${bulkTimePay.value}원으로 변경하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.timePay = bulkTimePay.value;
  emit('apply-bulk-time-pay', bulkTimePay.value);
};

// 일괄 시간당 임금 적용 (가족 60분)
const applyBulkTimePayFamily60 = () => {
  const numericValue = bulkTimePayFamily60.value.replace(/,/g, '');
  if (!numericValue || numericValue === '0') return;
  
  const confirmed = confirm(`모든 가족 60분 케어 시간당 임금을 ${bulkTimePayFamily60.value}원으로 변경하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.timePayFamily60 = bulkTimePayFamily60.value;
  emit('apply-bulk-time-pay-family-60', numericValue);
};

// 일괄 시간당 임금 적용 (가족 90분)
const applyBulkTimePayFamily90 = () => {
  if (!bulkTimePayFamily90.value || bulkTimePayFamily90.value === '0') return;
  
  const confirmed = confirm(`모든 가족 90분 케어 시간당 임금을 ${bulkTimePayFamily90.value}원으로 변경하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.timePayFamily90 = bulkTimePayFamily90.value;
  emit('apply-bulk-time-pay-family-90', bulkTimePayFamily90.value);
};

// 공통: 과거 데이터 수집 함수 (시간당 임금용 - 여러 달)
const fetchAllPreviousData = async (): Promise<Array<{ lebYm: string; data: any[] }>> => {
  if (!props.sisulCode || !props.lebYm) {
    return [];
  }
  
  const currentYear = parseInt(props.lebYm.substring(0, 4));
  const currentMonth = parseInt(props.lebYm.substring(4, 6));
  const currentLebYm = props.lebYm; // 현재 연월 저장
  
  loadingPreviousData.value = true;
  
  try {
    const allPreviousData: Array<{ lebYm: string; data: any[] }> = [];
    let searchMonth = currentMonth - 1;
    
    // 현재 연도 내에서만 과거 데이터 수집 (1월부터 현재 월-1까지)
    while (searchMonth >= 1) {
      const targetLebYm = `${currentYear}${String(searchMonth).padStart(2, '0')}`;
      
      // 현재 연월과 동일한 경우 건너뛰기 (중복 방지)
      if (targetLebYm === currentLebYm) {
        searchMonth--;
        continue;
      }
      
      try {
        const response = await axios.get('/api/calc/caregiver-member-join', {
          params: {
            sisulCode: props.sisulCode,
            lebYm: targetLebYm,
          },
        });
        
        const data = response.data.data || [];
        
        // 데이터가 존재하면 리스트에 추가 (최신순)
        if (data.length > 0) {
          allPreviousData.push({
            lebYm: targetLebYm,
            data: data
          });
        }
      } catch (error) {
        // 에러가 발생해도 계속 이전 달 검색
      }
      
      searchMonth--;
    }
    
    
    return allPreviousData;
    
  } catch (error: any) {
    console.error('데이터 조회 오류:', error);
    return [];
  } finally {
    loadingPreviousData.value = false;
  }
};

// 가장 최근 과거 데이터 가져오기 (수당 설정용 - 1개월만)
const fetchMostRecentPreviousData = async (): Promise<{ lebYm: string; data: any[] } | null> => {
  if (!props.sisulCode || !props.lebYm) {
    return null;
  }
  
  const currentYear = parseInt(props.lebYm.substring(0, 4));
  const currentMonth = parseInt(props.lebYm.substring(4, 6));
  const currentLebYm = props.lebYm; // 현재 연월 저장
  
  loadingPreviousData.value = true;
  
  try {
    let searchMonth = currentMonth - 1;
    
    // 현재 연도 내에서만 검색 (1월부터 현재 월-1까지)
    while (searchMonth >= 1) {
      const targetLebYm = `${currentYear}${String(searchMonth).padStart(2, '0')}`;
      
      // 현재 연월과 동일한 경우 건너뛰기 (중복 방지)
      if (targetLebYm === currentLebYm) {
        searchMonth--;
        continue;
      }
      
      try {
        const response = await axios.get('/api/calc/caregiver-member-join', {
          params: {
            sisulCode: props.sisulCode,
            lebYm: targetLebYm,
          },
        });
        
        const data = response.data.data || [];
        
        // 데이터가 존재하면 바로 반환
        if (data.length > 0) {
          return {
            lebYm: targetLebYm,
            data: data
          };
        }
      } catch (error) {
        // 에러가 발생해도 계속 이전 달 검색
      }
      
      searchMonth--;
    }
    
    return null;
    
  } catch (error: any) {
    console.error('데이터 조회 오류:', error);
    return null;
  } finally {
    loadingPreviousData.value = false;
  }
};

// 일괄 건강보험 적용/해제
const applyBulkHealthInsurance = (value: boolean) => {
  const action = value ? '적용' : '해제';
  const confirmed = confirm(`모든 요양보호사의 건강보험을 ${action}하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.healthInsurance = value;
  emit('apply-bulk-health-insurance', value);
};

// 일괄 휴일수당 적용 (공휴일가산 수가 서비스만 대상)
const applyBulkHolidayAllowance = (value: boolean) => {
  const action = value ? '지급' : '미지급';
  const confirmed = confirm(`모든 요양보호사의 휴일수당을 ${action}으로 설정하시겠습니까?\n(공휴일가산 수가가 있는 서비스만 대상)`);
  if (!confirmed) return;
  
  lastApplied.value.holiday = value;
  emit('apply-bulk-holiday-allowance', value);
};

// 일괄 연장수당 적용
const applyBulkOvertimeAllowance = (value: boolean) => {
  const action = value ? '지급' : '미지급';
  const confirmed = confirm(`모든 요양보호사의 연장수당을 ${action}으로 설정하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.overtime = value;
  emit('apply-bulk-overtime-allowance', value);
};

// 일괄 퇴직금 적용
const applyBulkRetirement = (value: boolean) => {
  const action = value ? '적립' : '미적립';
  const confirmed = confirm(`모든 요양보호사의 퇴직금을 ${action}으로 설정하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.retirement = value;
  emit('apply-bulk-retirement', value);
};

// 일괄 식대 적용
const applyBulkMealAllowance = (value: boolean) => {
  const action = value ? '지급' : '미지급';
  const confirmed = confirm(`모든 요양보호사의 식대를 ${action}으로 설정하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.meal = value;
  emit('apply-bulk-meal-allowance', value);
};

// 근속년수에 따라 장기근속수당 자동계산
const applyLongServiceAutoCalculate = () => {
  const confirmed = confirm('모든 요양보호사의 장기근속수당을 근속년수에 따라 자동으로 계산하시겠습니까?');
  if (!confirmed) return;
  
  lastApplied.value.longServiceAutoCalculate = true;
  lastApplied.value.longServiceClear = undefined;
  emit('apply-bulk-long-service-auto-calculate');
};

// 장기근속수당 모두 미지급 (0원)
const applyLongServiceClear = () => {
  const confirmed = confirm('모든 요양보호사의 장기근속수당을 미지급으로 설정하시겠습니까?');
  if (!confirmed) return;
  
  lastApplied.value.longServiceClear = true;
  lastApplied.value.longServiceAutoCalculate = undefined;
  emit('apply-bulk-long-service-clear');
};

// 보수교육비 일괄 설정 관련
const bosuEduPayAmount = ref('');

const onBosuEduPayAmountInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, '');
  if (value.length > 9) value = value.slice(0, 9);
  bosuEduPayAmount.value = value;
  input.value = value;
};

const onBosuEduPayAmountFocus = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  const numericValue = input.value.replace(/,/g, '');
  input.value = numericValue === '0' ? '' : numericValue;
  bosuEduPayAmount.value = input.value;
};

const onBosuEduPayAmountBlur = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  const numericValue = input.value.replace(/[^\d]/g, '');
  if (numericValue) {
    const formatted = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formatted;
    bosuEduPayAmount.value = formatted;
  }
};

// 보수교육비 일괄 적용
const applyBosuEduPayBulk = () => {
  const numericValue = bosuEduPayAmount.value.replace(/[^\d]/g, '');
  if (!numericValue || parseInt(numericValue) <= 0) {
    alert('보수교육비 금액을 입력해주세요.');
    return;
  }
  const confirmed = confirm(`모든 요양보호사에게 보수교육비 ${new Intl.NumberFormat('ko-KR').format(parseInt(numericValue))}원을 일괄 적용하시겠습니까?`);
  if (!confirmed) return;
  
  emit('apply-bulk-bosu-edu-pay', numericValue);
};

// 보수교육비 모두 미지급 (0원)
const applyBosuEduPayClear = () => {
  const confirmed = confirm('모든 요양보호사의 보수교육비를 미지급으로 설정하시겠습니까?');
  if (!confirmed) return;
  
  bosuEduPayAmount.value = '';
  emit('apply-bulk-bosu-edu-pay-clear');
};

// 모든 설정 불러오기
const applyAllPreviousSettings = async () => {
  const confirmed = confirm('모든 과거 설정(시간당 임금, 휴일수당, 연장수당, 퇴직금, 식대, 장기근속수당, 국민연금, 건강보험, 고용보험)을 불러오시겠습니까?');
  if (!confirmed) return;
  
  // 시간당 임금용 여러 달 데이터
  const allData = await fetchAllPreviousData();
  // 수당/보험용 최근 1개월 데이터
  const recentData = await fetchMostRecentPreviousData();
  
  if (allData.length > 0 || recentData) {
    lastApplied.value.allSettings = true;
    
    emit('apply-all-previous-settings', { allData, recentData: recentData! });
  }
};

// 일괄 근로자의날 수당 적용
const applyBulkLaborDayAllowance = (value: boolean) => {
  const action = value ? '지급' : '미지급';
  const confirmed = confirm(`모든 요양보호사의 근로자의날 수당을 ${action}으로 설정하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.laborDay = value;
  emit('apply-bulk-labor-day-allowance', value);
};

// 모든 설정 초기화
const resetAllSettings = () => {
  const confirmed = confirm('⚠️ 모든 급여 설정을 초기화하시겠습니까?\n\n- 모든 시급이 삭제됩니다.\n- 모든 체크박스가 해제됩니다.\n- 모든 수당/공제 금액이 초기화됩니다.\n\n이 작업은 되돌릴 수 없습니다.');
  if (!confirmed) return;
  
  emit('reset-all-settings');
  close();
};

// 시간당 임금 입력 포커스 이벤트 (컴마 제거)
const onTimePayFocus = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
  bulkTimePay.value = numericValue;
};

// 시간당 임금 입력 포커스 아웃 이벤트 (컴마 추가)
const onTimePayBlur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    bulkTimePay.value = formattedValue;
  } else {
    input.value = '';
    bulkTimePay.value = '';
  }
};

// 시간당 임금 입력 이벤트 (숫자만 허용)
const onTimePayInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  value = value.replace(/[^\d]/g, '');
  
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  
  input.value = value;
  bulkTimePay.value = value;
};

// 시간당 임금(가족 60분) 입력 포커스 이벤트 (컴마 제거)
const onTimePayFamily60Focus = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
  bulkTimePayFamily60.value = numericValue;
};

// 시간당 임금(가족 60분) 입력 포커스 아웃 이벤트 (컴마 추가)
const onTimePayFamily60Blur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    bulkTimePayFamily60.value = formattedValue;
  } else {
    input.value = '';
    bulkTimePayFamily60.value = '';
  }
};

// 시간당 임금(가족 60분) 입력 이벤트 (숫자만 허용)
const onTimePayFamily60Input = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  value = value.replace(/[^\d]/g, '');
  
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  
  input.value = value;
  bulkTimePayFamily60.value = value;
};

// 시간당 임금(가족 90분) 입력 포커스 이벤트 (컴마 제거)
const onTimePayFamily90Focus = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
  bulkTimePayFamily90.value = numericValue;
};

// 시간당 임금(가족 90분) 입력 포커스 아웃 이벤트 (컴마 추가)
const onTimePayFamily90Blur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    bulkTimePayFamily90.value = formattedValue;
  } else {
    input.value = '';
    bulkTimePayFamily90.value = '';
  }
};

// 시간당 임금(가족 90분) 입력 이벤트 (숫자만 허용)
const onTimePayFamily90Input = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  value = value.replace(/[^\d]/g, '');
  
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  
  input.value = value;
  bulkTimePayFamily90.value = value;
};

// props 변경 감지
watch(() => props.modelValue, (newVal) => {
  isOpen.value = newVal;
});

watch(isOpen, (newVal) => {
  if (!newVal) {
    emit('update:modelValue', false);
  } else {
    // 모달이 열릴 때 과거 데이터 체크
    checkPreviousData();
  }
});

// 연월 변경 시 과거 설정 상태 초기화
watch(() => props.lebYm, () => {
  lastApplied.value = {};
  bulkTimePay.value = '';
  bulkTimePayFamily60.value = '';
  bulkTimePayFamily90.value = '';
  // 연월이 변경되면 과거 데이터 다시 체크
  if (isOpen.value) {
    checkPreviousData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((isOpen).value = $event)),
    "max-width": "600px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
            default: _withCtx(() => [
              _cache[18] || (_cache[18] = _createElementVNode("span", null, "기능설정(모두저장을 눌러야 적용됩니다.)", -1)),
              _createVNode(_component_v_btn, {
                icon: "",
                size: "small",
                variant: "text",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, { class: "pa-8" }, {
            default: _withCtx(() => [
              (hasPreviousData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_btn, {
                      color: "success",
                      variant: "tonal",
                      block: "",
                      onClick: applyAllPreviousSettings,
                      loading: loadingPreviousData.value
                    }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode(" 모든 과거 설정 불러오기 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"])
                  ]))
                : _createCommentVNode("", true),
              (hasPreviousData.value)
                ? (_openBlock(), _createBlock(_component_v_divider, {
                    key: 1,
                    class: "mb-2"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "item-label" }, "시간당 임금 (일반)", -1)),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_text_field, {
                    modelValue: bulkTimePay.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bulkTimePay).value = $event)),
                    placeholder: "금액 입력",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    suffix: "원",
                    onInput: onTimePayInput,
                    onFocus: onTimePayFocus,
                    onBlur: onTimePayBlur,
                    style: {"max-width":"200px"}
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    onClick: applyBulkTimePay,
                    disabled: !bulkTimePay.value || bulkTimePay.value === '0'
                  }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createTextVNode(" 적용 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "item-label" }, "시간당 임금(가족 60분)", -1)),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_text_field, {
                    modelValue: bulkTimePayFamily60.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((bulkTimePayFamily60).value = $event)),
                    placeholder: "금액 입력",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    suffix: "원",
                    onInput: onTimePayFamily60Input,
                    onFocus: onTimePayFamily60Focus,
                    onBlur: onTimePayFamily60Blur,
                    style: {"max-width":"200px"}
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    onClick: applyBulkTimePayFamily60,
                    disabled: !bulkTimePayFamily60.value || bulkTimePayFamily60.value === '0'
                  }, {
                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                      _createTextVNode(" 적용 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "item-label" }, "시간당 임금(가족 90분)", -1)),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_text_field, {
                    modelValue: bulkTimePayFamily90.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((bulkTimePayFamily90).value = $event)),
                    placeholder: "금액 입력",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    suffix: "원",
                    onInput: onTimePayFamily90Input,
                    onFocus: onTimePayFamily90Focus,
                    onBlur: onTimePayFamily90Blur,
                    style: {"max-width":"200px"}
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    onClick: applyBulkTimePayFamily90,
                    disabled: !bulkTimePayFamily90.value || bulkTimePayFamily90.value === '0'
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode(" 적용 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "item-label" }, "건강보험", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (applyBulkHealthInsurance(true)))
                    }, {
                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                        _createTextVNode(" 일괄 적용 ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "grey",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (applyBulkHealthInsurance(false)))
                    }, {
                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                        _createTextVNode(" 일괄 해제 ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[31] || (_cache[31] = _createElementVNode("span", { class: "item-label" }, "휴일수당 (공휴일가산)", -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (applyBulkHolidayAllowance(true)))
                    }, {
                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                        _createTextVNode(" 일괄 지급 ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "grey",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (applyBulkHolidayAllowance(false)))
                    }, {
                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                        _createTextVNode(" 일괄 미지급 ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[34] || (_cache[34] = _createElementVNode("span", { class: "item-label" }, "연장수당", -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "primary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (applyBulkOvertimeAllowance(true)))
                    }, {
                      default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                        _createTextVNode(" 일괄 지급 ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "grey",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (applyBulkOvertimeAllowance(false)))
                    }, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode(" 일괄 미지급 ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[37] || (_cache[37] = _createElementVNode("span", { class: "item-label" }, "퇴직금", -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "primary",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (applyBulkRetirement(true)))
                    }, {
                      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                        _createTextVNode(" 일괄 지급 ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "grey",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (applyBulkRetirement(false)))
                    }, {
                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                        _createTextVNode(" 일괄 미지급 ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[40] || (_cache[40] = _createElementVNode("span", { class: "item-label" }, "식대", -1)),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "primary",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (applyBulkMealAllowance(true)))
                    }, {
                      default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                        _createTextVNode(" 일괄 지급 ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "grey",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (applyBulkMealAllowance(false)))
                    }, {
                      default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                        _createTextVNode(" 일괄 미지급 ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[43] || (_cache[43] = _createElementVNode("span", { class: "item-label" }, "장기근속수당", -1)),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "primary",
                      onClick: applyLongServiceAutoCalculate
                    }, {
                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                        _createTextVNode(" 자동 계산 ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "grey",
                      onClick: applyLongServiceClear
                    }, {
                      default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                        _createTextVNode(" 일괄 미지급 ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "d-flex align-center justify-space-between mb-2" }, [
                  _createElementVNode("span", { class: "item-label" }, "보수교육비")
                ], -1)),
                _createElementVNode("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((bosuEduPayAmount).value = $event)),
                    onInput: onBosuEduPayAmountInput,
                    onFocus: onBosuEduPayAmountFocus,
                    onBlur: onBosuEduPayAmountBlur,
                    class: "bulk-input",
                    placeholder: "금액 입력",
                    maxlength: "9",
                    style: {"width":"140px","height":"32px","border":"1px solid #e0e0e0","border-radius":"6px","padding":"0 8px","font-size":"0.875rem"}
                  }, null, 544), [
                    [_vModelText, bosuEduPayAmount.value]
                  ]),
                  _cache[46] || (_cache[46] = _createElementVNode("span", { style: {"font-size":"0.813rem","color":"#666"} }, "원", -1)),
                  _createVNode(_component_v_btn, {
                    size: "small",
                    variant: "flat",
                    color: "primary",
                    onClick: applyBosuEduPayBulk
                  }, {
                    default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                      _createTextVNode(" 일괄 적용 ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    size: "small",
                    variant: "flat",
                    color: "grey",
                    onClick: applyBosuEduPayClear
                  }, {
                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                      _createTextVNode(" 일괄 미지급 ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              (isLaborDayMonth.value && isLegacyYear.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[50] || (_cache[50] = _createElementVNode("span", { class: "item-label" }, "근로자의날 수당", -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          variant: "flat",
                          color: "primary",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (applyBulkLaborDayAllowance(true)))
                        }, {
                          default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                            _createTextVNode(" 일괄 지급 ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          size: "small",
                          variant: "flat",
                          color: "grey",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (applyBulkLaborDayAllowance(false)))
                        }, {
                          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                            _createTextVNode(" 일괄 미지급 ", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_divider, { class: "my-4" }),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "tonal",
                  block: "",
                  onClick: resetAllSettings
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                        _createTextVNode("mdi-refresh", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[52] || (_cache[52] = _createTextVNode(" 모든 급여 설정 초기화 ", -1))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})